import Vue from 'vue';
import Router from 'vue-router';
import BestPractices from './views/BestPractices.vue';
import BestTeachers from './views/BestTeachers.vue';
import NewestPractices from './views/NewestPractices.vue';
import Community from './views/Community.vue';
import Practice from './views/Practice.vue';
import Search from './views/Search.vue';
import SearchPractices from './views/SearchPractices.vue';
import SearchTeachers from './views/SearchTeachers.vue';
import Teacher from './views/Teacher.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'community',
      component: Community,
    },
    {
      path: '/best-practices/:page?',
      name: 'bestPractices',
      component: BestPractices,
      props: true,
    },
    {
      path: '/best-teachers/:page?',
      name: 'bestTeachers',
      component: BestTeachers,
      props: true,
    },
    {
      path: '/newest-practices/:page?',
      name: 'newestPractices',
      component: NewestPractices,
      props: true,
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      props: true,
    },
    {
      path: '/search/practices/:page?',
      name: 'searchPractices',
      component: SearchPractices,
      props: true,
    },
    {
      path: '/search/teachers/:page?',
      name: 'searchTeachers',
      component: SearchTeachers,
      props: true,
    },
    {
      path: '/:teacher',
      name: 'teacher',
      component: Teacher,
    },
    {
      path: '/:teacher/:practice',
      name: 'practice',
      component: Practice,
    },
  ],
});
